import { render, staticRenderFns } from "./info.vue?vue&type=template&id=13893ba0&scoped=true&"
import script from "./info.vue?vue&type=script&lang=js&"
export * from "./info.vue?vue&type=script&lang=js&"
import style0 from "./info.vue?vue&type=style&index=0&lang=less&"
import style1 from "./info.vue?vue&type=style&index=1&id=13893ba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13893ba0",
  null
  
)

export default component.exports